<template>
  <div class="holder">
    <div class="flex justify-center">
      <ImportIcon />
    </div>

    <!-- Text Here -->
    <div class="text-holder">
      <p>
        Upload a comma-separated value (CSV) file to generate a recipients list
        for faster ordering and shipping.
      </p>

      <!-- Download Template Here -->
      <div class="template">
        <DownloadTemplate />
      </div>
    </div>

    <!--Upload Button Region Here -->
    <div class="button-region">
      <UploadButton @import="handleImport" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    ImportIcon: () => import('./Icons/ImportIcon.vue'),
    UploadButton: () => import('./UploadButton.vue'),
    DownloadTemplate: () => import('./DownloadTemplate.vue')
  },

  methods: {
    handleImport(file) {
      this.$store.dispatch('recipient/handleImportRecipients', file)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.holder {
  margin-top: 4.5rem;

  .text-holder {
    margin-top: 1rem;
    color: #25282a;
    text-align: center;

    p {
      padding-bottom: 0.375rem;
      padding-top: 1rem;
      font-size: 0.813rem;
      font-weight: normal;
    }

    .template {
      margin-top: 0.5rem;
      display: flex;
      justify-content: center;
    }
  }

  .button-region {
    display: flex;
    justify-content: center;
    margin-top: 3.25rem;
  }
}
</style>
